export default __webpack_public_path__ + "static/media/5.65d10369.png";